module.exports = __webpack_public_path__ + "img/thumbs_up.19760e65.gif";